module.exports = "../../assets/img/sven-scheuermeier-178631-unsplash.jpg";